import React from "react";

const HamburgurIconBlack = () => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.825 13.7H14.575C15.0306 13.7 15.4 14.0694 15.4 14.525C15.4 14.9427 15.0896 15.2878 14.6869 15.3425L14.575 15.35H0.825C0.369365 15.35 0 14.9806 0 14.525C0 14.1073 0.310369 13.7622 0.713052 13.7075L0.825 13.7ZM0.825 9.3H21.175C21.6306 9.3 22 9.66936 22 10.125C22 10.5427 21.6896 10.8878 21.2869 10.9425L21.175 10.95H0.825C0.369365 10.95 0 10.5806 0 10.125C0 9.70733 0.310369 9.36216 0.713052 9.30753L0.825 9.3ZM0.825 4.9H21.175C21.6306 4.9 22 5.26936 22 5.725C22 6.14266 21.6896 6.48784 21.2869 6.54247L21.175 6.55H0.825C0.369365 6.55 0 6.18063 0 5.725C0 5.30733 0.310369 4.96216 0.713052 4.90753L0.825 4.9ZM0.825 0.5H21.175C21.6306 0.5 22 0.869365 22 1.325C22 1.74267 21.6896 2.08784 21.2869 2.14247L21.175 2.15H0.825C0.369365 2.15 0 1.78063 0 1.325C0 0.907335 0.310369 0.56216 0.713052 0.507531L0.825 0.5Z"
        fill="black"
      />
    </svg>
  );
};

export default HamburgurIconBlack;
